export default "__VITE_ASSET__AeKF1PfH__"